import { render, staticRenderFns } from "./coachList.vue?vue&type=template&id=3928378a&"
import script from "./coachList.vue?vue&type=script&lang=js&"
export * from "./coachList.vue?vue&type=script&lang=js&"
import style0 from "./coachList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports